/**
 * LanguageSwitch — przełącznik PL/EN dla publicznych ankiet.
 */
import React from 'react';
import { LANGS } from './surveyI18n';

export default function LanguageSwitch({ value, onChange }) {
  return (
    <div style={{
      position: 'absolute', top: 14, right: 14,
      display: 'inline-flex', gap: 4, padding: 4,
      background: 'rgba(255,255,255,0.05)', borderRadius: 999,
      border: '1px solid rgba(212,175,55,0.20)',
      zIndex: 5,
    }} data-testid="public-lang-switch">
      {LANGS.map((L) => {
        const active = value === L.code;
        return (
          <button
            key={L.code}
            onClick={() => onChange(L.code)}
            data-testid={`public-lang-${L.code}`}
            style={{
              padding: '4px 10px', borderRadius: 999, border: 'none',
              background: active ? 'linear-gradient(135deg, #d4af37, #b8860b)' : 'transparent',
              color: active ? '#1a1300' : '#cbd5e1',
              fontSize: 12, fontWeight: 800, cursor: 'pointer',
              transition: 'all 0.2s',
            }}
          >{L.flag} {L.label}</button>
        );
      })}
    </div>
  );
}
